<template>
  <b-card v-loading="loading" :element-loading-text="loadingText">
    <h4>Account Details</h4>
    <b-alert :show="updated" dismissible fade variant="success" class="mt-2" @dismissed="updated = false" @dismiss-count-down="(i) => updated = i">Account details updated successfully!</b-alert>
    <b-form class="mt-3">
      <b-row>
        <b-col :sm="6">
          <b-form-group>
            <label>First Name</label>
            <b-form-input v-model="account.firstName" type="text" placeholder="ex. John"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col :sm="6">
          <b-form-group>
            <label>Last Name</label>
            <b-form-input v-model="account.lastName" type="text" placeholder="ex. Smith"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group>
        <label>Email Address</label>
        <b-form-input v-model="account.email" type="text" placeholder="ex. someone@example.com"></b-form-input>
      </b-form-group>
      <b-button variant="primary" @click="updateProfile()">Save</b-button>
      <b-alert :show="!!error" fade variant="danger" class="mt-4 mb-0">{{error}}</b-alert>
    </b-form>
  </b-card>
</template>

<script>
const LoadingText = 'Loading Account Info...'
const UpdatingText = 'Updating Account Info...'

export default {
  name: 'AccountDetails',

  data(){
    return {
      account : {
        firstName: this.$session.get('firstName'),
        lastName  : this.$session.get('lastName'),
        email     : this.$session.get('email'),
      },

      // State
      loading     : false,
      loadingText : LoadingText,
      error       : '',
      updated     : false,
    }
  },

  methods: {
    updateProfile(){
      const { firstName, lastName, email } = this.account

      this.loading = true
      this.loadingText = UpdatingText
      this.$API.v2.Account.UpdateProfile(firstName, lastName, email)
      .then((account) => {
        this.account = account
        this.updated = 5
      })
      .catch((err) => {
        this.error = err
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
};
</script>
